module.exports = __webpack_public_path__ + "front/img/42.32520fa6.png";